"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("@formatjs/intl-pluralrules/polyfill");

require("@formatjs/intl-pluralrules/locale-data/es");

require("@formatjs/intl-pluralrules/locale-data/en");

require("@formatjs/intl-relativetimeformat/polyfill");

require("@formatjs/intl-relativetimeformat/locale-data/es");

require("@formatjs/intl-relativetimeformat/locale-data/en");

var _IntlSetter = _interopRequireDefault(require("../IntlSetter"));

var IntlProvider = function IntlProvider(_ref) {
  var locale = _ref.locale,
      messages = _ref.messages,
      children = _ref.children,
      moreProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["locale", "messages", "children"]);
  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, (0, _extends2.default)({
    locale: locale,
    messages: messages[locale]
  }, moreProps), /*#__PURE__*/_react.default.createElement(_IntlSetter.default, null, children));
};

IntlProvider.propTypes = {
  children: _propTypes.default.node,
  locale: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object
};
IntlProvider.defaultProps = {
  messages: {}
};
IntlProvider.displayName = 'IntlProvider';
var _default = IntlProvider;
exports.default = _default;